/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './political-entity-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-political-entity-list-page',
  template
})
export class PoliticalEntityListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.pol.political-entities.political-entity';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'type'},
    {param: 'ownerTeam', labelInstant: 'Owner team', sortable: false},
    {param: 'legalEntity', labelInstant: 'Legal Entity', sortable: false},
    {param: 'contactEmail', labelInstant: 'Contact Email'},
    {param: 'siteUrl', labelInstant: 'URL'}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    super(LocalNetworkProfile);
  }

  ownerTeamLabel(entity: any): string {
    return (entity.ownerTeam && entity.ownerTeam.name) || entity.ownerTeam || '';
  }

  legalEntityLabel(entity: any): string {
    return entity.legalEntity || '';
  }
}
